import { useQuery } from '@tanstack/react-query';
import { useLocation } from '@/shared/hooks/useLocation';
import { adsApi } from '../api/adsApi';
import type { OverviewRange } from '../api/campaignsApi';
import { adsKeys } from '../queryKeys';

export function useAdsMetrics(range?: OverviewRange) {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';
  return useQuery({
    queryKey: adsKeys.metrics(locationId, range ?? 'mtd'),
    queryFn: () => adsApi.getMetrics(locationId, range),
    enabled: !!locationId,
  });
}
